import { AlertsReportModel } from "../models/alerts-report";
import { autoinject, Container } from "aurelia-dependency-injection";
import { backboneViewProperties } from "../../decorators/backbone-properties";
import { AppEvents } from "../../app-events";
import { ContainerHelper } from "../../shared/helpers/container-helper";

const template = require<string>("../views/alerts-report.html");

const dom = {
    SLIDER: ".slider",
    REPORT_ENABLED: ".report-enabled input"
};

@backboneViewProperties({
    tagName: "tr",
    template
})
@autoinject
export class AlertsReportView extends Marionette.ItemView<AlertsReportModel> {
    private appEvents: Backbone.Events;

    constructor(options?) {
        super(options);
        this.appEvents = ContainerHelper.Events;
    }

    public events(): Backbone.EventsHash {
        const events: Backbone.EventsHash = {};
        events["click " + dom.SLIDER] = (e) => this.sliderClick(e);
        return events;
    }

    private sliderClick(e: JQueryEventObject) {
        this.model.Enabled = !this.model.Enabled;
        this.saveAlert();
    }

    private saveAlert() {
        this.appEvents.trigger(AppEvents.AppInsightsAlertChange, {Type: "ReportSeries", Value: this.model.ReportName, Enabled: this.model.Enabled});

        this.model.saveAlert().then(() => {
            this.$(dom.REPORT_ENABLED).prop("checked", this.model.Enabled);
            this.$(dom.REPORT_ENABLED).val("" + this.model.Enabled);
            this.appEvents.trigger(AppEvents.InformationMessage, "The alert for " + this.model.ReportName + " has been " + (this.model.Enabled ? "Enabled" : "Disabled"));
        }, () => {
            this.appEvents.trigger(AppEvents.ErrorMessage, "Unable to save alert for " + this.model.ReportName);
            this.RevertCheckbox();
        }).catch((exception) => {
            this.appEvents.trigger(AppEvents.ErrorMessage, "Unable to save alert for " + this.model.ReportName);
            this.RevertCheckbox();
        });
    }

    private RevertCheckbox() {
        this.model.Enabled = !this.model.Enabled;
        this.$(dom.SLIDER).prop("checked", this.model.Enabled);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/my-justis/views/alerts-report.ts